<dxo-modal *ngIf="showModal" title="Are you still there?" (closeModal)="onClose()">
  <modal-body>
    <p>If you do not continue, you will be disconnected in {{ formattedTime }} minutes. To continue, click the
      button below.</p>
    <dxo-button (handleClick)="onClose()" text="Continue"></dxo-button>
    <dxo-button class="logout-button" [textButton]="true" text="Logout" (handleClick)="logoutUser()" [dxoDataset]="logoutDataset"></dxo-button>
  </modal-body>
</dxo-modal>
